import React from "react"
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl"
import "./tooltip.scss"
import {
	gender,
	channel,
	removeSpaces,
} from "components/Transactional/GrowthProfiling/utils"

interface TooltipProps {
	indexValue: string
	data: Record<string, any>
	color: string
}

const Tooltip: React.FC<TooltipProps> = ({ indexValue, data, color }) => {
	const intl = useIntl()
	return (
		<div className="chart-tooltip">
			<div className="color" style={{ background: color }} />
			<div>
				<strong>
					{gender.includes(indexValue) || channel.includes(indexValue)
						? intl.formatMessage({
								id: `phronesis.common.${removeSpaces(indexValue)}`,
						  })
						: indexValue}
				</strong>
				<br />
				<FormattedMessage
					id="phronesis.transactional.application.growth-profiling.chart.age.tooltip"
					values={{
						actualValue: (
							<FormattedNumber
								value={data?.value / 100}
								style="percent"
								minimumFractionDigits={1}
							/>
						),
						varValue: (
							<FormattedNumber
								value={data?.variation}
								style="percent"
								minimumFractionDigits={1}
							/>
						),
					}}
				/>
			</div>
		</div>
	)
}

export default Tooltip
